import React from 'react'

import InputField from '../../InputField/InputField.component'

import { Grid, Paper, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

export default function ShippingEquipmentInput({ equipmentName, currentQty, prefix, handleChange, shippedQty, handleRemove, errors}) {

    return (<Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, paddingBottom: 0, marginBottom: 2}}>
                <Grid container rowSpacing={2} alignItems={'center'}>
                    <Grid item xs={8}><Typography variant="h6">{equipmentName}</Typography></Grid>
                    <Grid item xs={4} textAlign={'right'}>Current Qty: {currentQty}</Grid>
                    <Grid item xs={12}>
                        <InputField 
                            id={`${prefix}.quantity`}
                            type="text"
                            placeholder='Qty Shipped'
                            onChange={handleChange}
                            value={shippedQty}
                            isValid={errors['quantity']}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </Grid>)
}